enum BillingTypes {
  STRIPE = 'stripe',
}

export default BillingTypes
